import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getClientToken() {
  try {
    const result = yield call(API.getClientToken);
    yield put({
      type: actionTypes.PAYMENT_CLIENT_TOKEN_SUCCESS,
      clientToken: result.client_token,
    });
  } catch (error) {
    yield put({ type: actionTypes.PAYMENT_CLIENT_TOKEN_ERROR, error });
  }
}

export function* checkout({ options }) {
  try {
    const result = yield call(API.checkout, options);
    if (result.result === 'success') {
      yield put({ type: actionTypes.PAYMENT_CHECKOUT_SUCCESS });
    } else {
      yield put({ type: actionTypes.PAYMENT_CHECKOUT_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.PAYMENT_CHECKOUT_ERROR, error });
  }
}

export function* getCustomer({ options }) {
  try {
    const result = yield call(API.getCustomer, options);
    if (result.id) {
      yield put({
        type: actionTypes.PAYMENT_GET_CUSTOMER_SUCCESS,
        customer: result,
      });
    } else {
      yield put({ type: actionTypes.PAYMENT_GET_CUSTOMER_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.PAYMENT_GET_CUSTOMER_ERROR, error });
  }
}

export function* getSubscription({ options }) {
  try {
    const result = yield call(API.getSubscription, options);
    if (result.id) {
      yield put({
        type: actionTypes.PAYMENT_GET_SUBSCRIBE_SUCCESS,
        subscription: result,
      });
    } else {
      yield put({ type: actionTypes.PAYMENT_GET_SUBSCRIBE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.PAYMENT_GET_SUBSCRIBE_ERROR, error });
  }
}

export function* subscribe({ options }) {
  try {
    const result = yield call(API.subscribe, options);
    if (result.id) {
      yield put({
        type: actionTypes.PAYMENT_SUBSCRIBE_SUCCESS,
        subscription: result,
      });
    } else {
      yield put({ type: actionTypes.PAYMENT_SUBSCRIBE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.PAYMENT_SUBSCRIBE_ERROR, error });
  }
}

export function* pay({ options }) {
  try {
    const result = yield call(API.pay, options);
    if (result.id) {
      yield put({
        type: actionTypes.PAYMENT_TRANSACTION_SUCCESS,
        transaction: result,
      });
    } else {
      yield put({ type: actionTypes.PAYMENT_TRANSACTION_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.PAYMENT_TRANSACTION_ERROR, error });
  }
}

export function* cancelSubscribe({ options }) {
  try {
    const result = yield call(API.cancelSubscribe, options);
    if (result.result === 'success') {
      yield put({ type: actionTypes.PAYMENT_CANCEL_SUBSCRIBE_SUCCESS });
    } else {
      yield put({ type: actionTypes.PAYMENT_CANCEL_SUBSCRIBE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.PAYMENT_CANCEL_SUBSCRIBE_ERROR, error });
  }
}

export function* getSubscriptionPlans({ options }) {
  try {
    const result = yield call(API.getSubscriptionPlans, options);
    if (result.id) {
      yield put({
        type: actionTypes.PAYMENT_GET_PLANS_SUCCESSL,
        plans: result,
      });
    } else {
      yield put({ type: actionTypes.PAYMENT_GET_PLANS_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.PAYMENT_GET_PLANS_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/payment.js